import { FC, useRef } from "react";
import { Box, Image } from "@chakra-ui/react";
import "../../../css/ImageGallery.scss";
import { HeightCalculation, WidthCalculation } from "../../SizeCaluculation";

export const LogoSymbol: FC = () => {
  const pressTimer = useRef<NodeJS.Timeout | null>(null);
  const LONG_PRESS_DURATION_MS = 15 * 1000; // 15秒

  const handleTouchStart = () => {
    pressTimer.current = setTimeout(() => {
      console.log("ロゴ長押しによるリロードを実行します");
      window.location.reload();
    }, LONG_PRESS_DURATION_MS);
  };

  const handleTouchEnd = () => {
    if (pressTimer.current) clearTimeout(pressTimer.current);
  };

  const handleTouchMove = () => {
    if (pressTimer.current) clearTimeout(pressTimer.current);
  };

  let width: number;
  let height: number;
  let leftPosition: string;

  width =
    process.env.REACT_APP_SHOW_MULTI_MENU === "true"
      ? WidthCalculation(330, 324)
      : WidthCalculation(430, 324);
  height =
    process.env.REACT_APP_SHOW_MULTI_MENU === "true"
      ? HeightCalculation(90, 300)
      : HeightCalculation(270, 300);

  if (window.innerWidth > window.innerHeight) {
    leftPosition =
      process.env.REACT_APP_SHOW_MULTI_MENU === "true" ? "55%" : "50%";

    return (
      // 横長
      <Box
        mt="0px"
        borderRadius="3xl"
        width={`${width}px`}
        height={`${height}px`}
        boxShadow="none"
        bg="transparent"
        position="relative"
        maxWidth="100%"
      >
        <Box
          position="absolute"
          left={leftPosition}
          top="5%"
          transform="translate(-50%)"
        >
          <Image
            width={`${width * 0.6}px`}
            src="/svg/logo.svg"
            alt="logo"
            maxW={`${width}px`}
            className="logo-symbol-yoko"
            onTouchStart={handleTouchStart}
            onTouchEnd={handleTouchEnd}
            onTouchMove={handleTouchMove}
          />
        </Box>
      </Box>
    );
  } else {
    return (
      // 縦長
      <Box
        mt="25px"
        textAlign="center"
        borderRadius="3xl"
        boxShadow="none"
        bg="transparent"
        position="relative"
        overflow="auto"
        maxWidth="100%"
        height={`${height}px`}
        width={`${width}px`}
      >
        <Box
          position="absolute"
          left="50%"
          top="40%"
          transform="translate(-50%)"
        >
          <Image
            width={`${width * 0.6}px`}
            src="/svg/logo.svg"
            alt="logo"
            maxW={`${width}px`}
            className="logo-symbol-tate"
            onTouchStart={handleTouchStart}
            onTouchEnd={handleTouchEnd}
            onTouchMove={handleTouchMove}
          />
        </Box>
      </Box>
    );
  }
};
